import * as Yup from "yup";

const campaignValidationSchema = Yup.object().shape({
  attachments: Yup.array(),
  emailSignature: Yup.string().required("Email signature is required."),
  emailSubject: Yup.string().required("Email subject is required."),
  emailTemplate: Yup.string().required("Email template is required."),
  jobTitle: Yup.string().required("Job title is required."),
  name: Yup.string().required("Campaign name is required."),
  organizationName: Yup.string().required("Organization name is required."),
  personalizedEmailsForContacts: Yup.array().of(
    Yup.object().shape({
      emailBody: Yup.string().required("Email body is required."),
      emailSubject: Yup.string().required("Email subject is required."),
      id: Yup.string().required(),
      personalized: Yup.boolean().required(),
    }),
  ),
  technologySummary: Yup.string().required("Technology summary is required."),
});

export default campaignValidationSchema;
